var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8 2.267A6.24 6.24 0 0 0 1.767 8.5 6.24 6.24 0 0 0 8 14.734 6.24 6.24 0 0 0 14.233 8.5 6.24 6.24 0 0 0 8 2.267M.667 8.5A7.34 7.34 0 0 1 8 1.167 7.34 7.34 0 0 1 15.333 8.5 7.34 7.34 0 0 1 8 15.834 7.34 7.34 0 0 1 .667 8.5",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8 5.484c-.801 0-1.45.649-1.45 1.45a.55.55 0 0 1-1.1 0 2.55 2.55 0 0 1 5.1 0c0 .972-.646 1.586-1.108 2.026l-.062.06c-.52.497-.83.836-.83 1.362a.55.55 0 1 1-1.1 0c0-1.039.667-1.677 1.146-2.135l.024-.022c.536-.513.83-.82.83-1.291 0-.801-.65-1.45-1.45-1.45",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.541 12.15a.542.542 0 1 1-1.083 0 .542.542 0 0 1 1.083 0"
})));
export { SvgHelp as ReactComponent };